<h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="meritoForm">
<form [formGroup]="meritoForm" (ngSubmit)="update();">
	<div class="row">
		<div comboModInput [control]="meritoForm.controls['dettaglioEsito']"
			[class]="inserimento ? 'col-sm-6':'col-sm-4'"
			[labelInput]="'Risoluzione per parte'" formControlName="dettaglioEsito"
			[objectReference]="dettaglioEsito.tipoDettaglio"
			(onReturn)="dettaglioEsito.tipoDettaglio = $event"
			[optionsCombo] ="tipiDettaglioEsito" [mandatory]="true"
			[ngModel]="dettaglioEsito.tipoDettaglio">
		</div>
		<div comboModInput [control]="meritoForm.controls['classificazione']"
			[class]="inserimento ? 'col-sm-6':'col-sm-4'" [labelInput]="'Classificazione'"
			formControlName="classificazione"
			[objectReference]="dettaglioEsito.classificazione"
			[mandatory]="true"
			(onReturn)="dettaglioEsito.classificazione = $event"
			[ngModel]="dettaglioEsito.classificazione"
			[labelOption]="'materia.label+oggetto.label+argomento.label'"
			[labelOptionSeparator]="' '" [optionsCombo] ="classificazioniOptions"></div>
		<div comboModInput *ngIf="!inserimento" [control]="meritoForm.controls['controparte']"
			class="col-sm-4" [labelInput]="'Parte'"
			formControlName="controparte"
			[objectReference]="dettaglioEsito.controparte"
			[mandatory]="true"
			(onReturn)="dettaglioEsito.controparte = $event"
			[ngModel]="dettaglioEsito.controparte"
			[labelOption]="'parte.nominativo'"
			[optionsCombo] ="controparti"></div>
	</div>
	<div class="row" *ngIf="inserimento">
			<div class="col-sm-12">
			<strong>Parti</strong><span class="mandatory">*</span>
			<table class="table-striped table aggiunta_classificazione" style="margin-top: 8px;">
				<caption class="sr-only">Tabella parti</caption>
				<tbody>
					<tr>
						<th>Nominativo</th>
						<th>Codice fiscale</th>
						<th>
							<div singleCheckBoxModInput [labelChecked]="'Seleziona'" [labelNotChecked]="'Seleziona'"
								[labelSemibold]="true" idInput="selected"
								[objectReference]="contropartiDettagli && contropartiDettagli.length>0 && controparti.length>0 && controparti.length===contropartiDettagli.length"
								class="col-sm-4" (onReturn)="onSelectAllControparti($event);"></div>
						</th>
					</tr>
					<ng-template ngFor let-controparte [ngForOf]="controparti">
						<tr>
							<td>
								<p *ngIf="controparte.parte?.nominativo">
									{{controparte.parte?.nominativo | capitalize}}
								</p>
								<p
									*ngIf="!controparte.parte?.nominativo && controparte.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
									{{controparte.parte?.cognome | capitalize}}
									{{' ' + controparte.parte?.nome | capitalize}}
								</p>
								<p
									*ngIf="!controparte.parte?.nominativo && controparte.parte.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
									{{controparte.parte?.ragioneSociale}}
								</p>
							</td>
							<td>
								<p *ngIf="controparte.parte?.codiceFiscale">
									{{controparte.parte?.codiceFiscale | uppercase }}
								</p>
							</td>
							<td>
								<div singleCheckBoxModInput [labelInput]="''" [showLabel]="false" idInput="element"
									class="col-sm-4" [objectReference]="isSelectedControparte(controparte)"
									(onReturn)="onSelectControparte($event, controparte);"></div>
							</td>
						</tr>
					</ng-template>
				</tbody>
			</table>

		</div>

	</div>
	<div class="row" *ngIf="controparti?.length === 0">
		<div class="col-sm-12">
			<p>{{msgNoControparti}}</p>
		</div>
	</div>
	<div class="row">
		<p class="mandatory col-sm-12">
			<em>* Campi obbligatori</em>
		</p>
	</div>
	<div class="row">
		<p class="col-sm-3 col-xs-6">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="createForm();">Reset</button>
		</p>
		<p submitButton
			class="col-sm-3 col-xs-6 col-sm-offset-6"
			[labelButton]="'Salva'" [disabled]="!meritoForm.valid || (inserimento && contropartiDettagli.length === 0 ) || (!inserimento && !dettaglioEsito.controparte)"></p>
	</div>
</form>
</ng-template>
